import { SatelliteDeviceModel } from "@safetyculture/s12-apis-connect-web/s12/loneworker/v1/satellite_pb";

export interface ModelOption {
  label: string;
  value: SatelliteDeviceModel;
}

export const MODEL_OPTIONS: ModelOption[] = [
  {
    label: "Garmin inReach Mini",
    value: SatelliteDeviceModel.GARMIN_INREACH_MINI,
  },
  {
    label: "Garmin inReach Mini 2",
    value: SatelliteDeviceModel.GARMIN_INREACH_MINI_2,
  },
  {
    label: "Garmin inReach Mini 3",
    value: SatelliteDeviceModel.GARMIN_INREACH_MINI_3,
  },
  { label: "SPOT 1", value: SatelliteDeviceModel.SPOT_1 },
  { label: "SPOT 2", value: SatelliteDeviceModel.SPOT_2 },
  { label: "SPOT 3", value: SatelliteDeviceModel.SPOT_3 },
  { label: "SPOT 4", value: SatelliteDeviceModel.SPOT_4 },
];

export const getSatelliteDeviceModel = (label: string): SatelliteDeviceModel =>
  MODEL_OPTIONS.find((option) => option.label === label)?.value ??
  SatelliteDeviceModel.UNSPECIFIED;

export const getSatelliteDeviceModelLabel = (
  model: SatelliteDeviceModel,
): string =>
  MODEL_OPTIONS.find((option) => option.value === model)?.label ?? "";
